export const SUCCESS_API_CALL = "SUCCESS_API_CALL";
export const LOAD_ORDER_LOADING = 'LOAD_ORDER_LOADING';
export const LOAD_ORDER_SUCCESS = 'LOAD_ORDER_SUCCESS';
export const LOAD_ORDER_ERROR = 'LOAD_ORDER_ERROR';
export const MANAGE_LOADING = 'MANAGE_LOADING';
export const MANAGE_REGISTER_LOADING = 'MANAGE_REGISTER_LOADING';
export const ERROR_API_CALL = 'ERROR_API_CALL';
export const MANAGE_STORE_DEL_OPT_LOADING = 'MANAGE_STORE_DEL_OPT_LOADING';
export const MANAGE_STORE_DEL_OPT_LOADED = 'MANAGE_STORE_DEL_OPT_LOADED';
export const LANGUAGE_HAS_CHANGED = 'LANGUAGE_HAS_CHANGED';
